// extracted by mini-css-extract-plugin
export var cancelButton = "_l5-5";
export var content = "_l5-3";
export var createButton = "_l5-6";
export var drawerContainer = "_l5-0";
export var footer = "_l5-2";
export var header = "_l5-1";
export var orderFormColumn = "_l5-4";